/**
 * ticketSalesCampaignsRoutes — the campaign pages, defined beside the feature
 * rather than inline in `AdminRoutes.tsx` (the `giftCardsRoutes` pattern).
 * Paths are relative; admin mode mounts them under `/admin/*`, and they match
 * `ticket-sales-campaigns-paths.ts`. Their fixed segments outrank the
 * `marketing/*` catch-all that serves the ad dashboard.
 *
 * The list needs the read scope; creating and editing need the write scope.
 * Only Admin and Marketing hold either.
 */
import { Route } from 'react-router-dom';

import RequirePermission from '../../shared/RequirePermission';
import { Permission } from '../../types/permissions';

import TicketSalesCampaignCreatePage from './TicketSalesCampaignCreatePage';
import TicketSalesCampaignEditPage from './TicketSalesCampaignEditPage';
import TicketSalesCampaignsListPage from './TicketSalesCampaignsListPage';

export const ticketSalesCampaignsRoutes = (
  <>
    <Route
      path="marketing/campaigns"
      element={
        <RequirePermission permission={Permission.READ_TICKET_SALES_CAMPAIGNS}>
          <TicketSalesCampaignsListPage />
        </RequirePermission>
      }
    />
    <Route
      path="marketing/campaigns/new"
      element={
        <RequirePermission permission={Permission.WRITE_TICKET_SALES_CAMPAIGNS}>
          <TicketSalesCampaignCreatePage />
        </RequirePermission>
      }
    />
    <Route
      path="marketing/campaigns/:id"
      element={
        <RequirePermission permission={Permission.WRITE_TICKET_SALES_CAMPAIGNS}>
          <TicketSalesCampaignEditPage />
        </RequirePermission>
      }
    />
  </>
);
